import { ExecutableAction, ExecutableActionParam } from '@records/state/utils/executable-action';
import { of } from 'rxjs';
import { CurrentDataModel } from '../current-data.model';

export class AddPropertyTypesAction implements ExecutableAction<CurrentDataModel> {
  static readonly type = '[Current Data] Add PropertyTypes Action';

  execute(_params: ExecutableActionParam<CurrentDataModel>) {
    of(true);
  }
}
